class Price {
    constructor(id, name, singlePrice, amount) {
        this.id = id;
        this.name = name;
        this.singlePrice = singlePrice;
        this.amount = amount;
    }

    update(name, singlePrice, amount) {
        this.name = name;
        this.singlePrice = singlePrice;
        this.amount = amount;
    }

    getTotal() {
        return this.singlePrice * this.amount;
    }
}


export default class Prices {
    constructor() {
        this.rows = [];
        this.discounts = [];
        this.donation = 0;
    }

    createRow(id, name, singlePrice, amount) {
        let row = new Price(id, name, singlePrice, amount);
        this.rows.push(row);
    }

    getRow(id) {
        for(let row of this.rows) {
            if(row.id === id) {
                return row;
            }
        }
        return null;
    }

    updateOrCreateRow(id, name, singlePrice, amount) {
        let row = this.getRow(id);
        if(row) {
            row.update(name, singlePrice, amount);
        } else {
            this.createRow(id, name, singlePrice, amount);
        }
    }

    deleteRow(id) {
        this.rows = this.rows.filter((row) => {
            return row.id !== id;
        });
    }

    resetDiscount() {
        this.discounts = [];
    }

    setDiscount(name, discount) {
        let row = new Price('', name, discount, 1);
        this.discounts.push(row);
    }

    setDonation(donation) {
        this.donation = donation;
    }

    getRowTotal() {
        let total = 0;
        for(let row of this.rows) {
            total += row.getTotal();
        }
        return Math.round(total * 100) / 100;
    }

    getDiscountTotal() {
        let total = 0;
        for(let discount of this.discounts) {
            total += discount.getTotal();
        }
        return Math.round(total * 100) / 100;
    }

    calculateTotal() {
        let total = this.getRowTotal() + this.donation - this.getDiscountTotal();
        return Math.round(total * 100) / 100;
    }
}




// WEBPACK FOOTER //
// ./src/my_artis/js/data/expositions/prices.js